import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  Stack,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import VerifiedIcon from "@mui/icons-material/Verified";
import { CustomDivider, SelectDropdown, Wrapper } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
 
const hostname = window.location.hostname;
const stageHostnames = ["localhost", "127.0.0.1"];
 
const baseMap = {
  "customer-test.finhub.habilelabs.io": "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc/dashboard",
  "finhub-stage.habilelabs.io": "https://customer-vkyc-stage.finhub.habilelabs.io/vkyc/dashboard",
  "customer.finhub.habilelabs.io": "https://customer-vkyc.finhub.habilelabs.io/vkyc/dashboard"
};
 
const baseURL = stageHostnames.includes(hostname)
  ? "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc/dashboard"
  : baseMap[hostname] || "https://customer-vkyc.finhub.habilelabs.io/vkyc/dashboard";
 
console.log('KYCUserService - Base URL:', baseURL);
console.log('KYCUserService - Hostname:', hostname);
 
const StyledCard = styled(Card)(() => ({
  borderRadius: "16px",
  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  borderLeft: "4px solid #10b981",
  transition: "all 0.2s ease-in-out",
  cursor: "pointer",
  height: "100%",
  "&:hover": {
    boxShadow: "0 8px 25px -8px rgba(0, 0, 0, 0.15)",
    transform: "translateY(-4px)",
  },
}));


const CategoryCard = ({ user }) => {
  const handleCardClick = () => {
    const role = user?.role?.toLowerCase();
    if (role === "admin" || role === "vkyc auditor") {
      const sourceURL = window.location.origin;
      window.open(`${baseURL}?token=${user.jwt}&source=${sourceURL}`, "_blank");
    }
  };

  const isClickable =
    user?.role?.toLowerCase() === "admin" ||
    user?.role?.toLowerCase() === "vkyc auditor";

  return (
    <StyledCard
      sx={{
        maxWidth: 360,
        cursor: isClickable ? "pointer" : "not-allowed",
        opacity: isClickable ? 1 : 0.7,
      }}
      onClick={handleCardClick}
    >
      <CardContent
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Status */}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Chip
            label="Subscribed"
            size="small"
            sx={{
              backgroundColor: "#16a249",
              color: "#fff",
              fontSize: "11px",
              fontWeight: 600,
              height: 24,
            }}
          />
        </Box>

        {/* Title */}
        <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
          <VerifiedIcon sx={{ color: "#10b981", mr: 1 }} />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#1e293b",
              fontSize: "18px",
            }}
          >
            Intelli VKYC
          </Typography>
        </Box>

        {/* Category Tag */}
        <Stack direction="row" spacing={1} sx={{ mt: 1, mb: 1 }}>
          <Chip
            label="Verification"
            size="small"
            sx={{
              backgroundColor: "#F1F5F9",
              color: "#0F1729",
              fontSize: "12px",
              fontWeight: 700,
              padding: "10px",
            }}
          />
        </Stack>

        {/* Description */}
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            color: "#000",
            fontSize: "15px",
            mb: 2,
          }}
        >
          A comprehensive video-based KYC solution that enables real-time customer verification through secure, 
          compliant, and automated video interactions. 
        </Typography>
      </CardContent>
    </StyledCard>
  );
};

export const ProductCatalog = () => {
  const { user } = useSelector((state) => state.auth);
  return (
     <Wrapper>
     <Box sx={{ mt: { xs: 10, sm: 12, md: 12 }, mb: 2 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 500,
            color: "#65758B",
            fontSize: "14px",
          }}
        >
          Explore our suite of advanced digital verification and onboarding products, 
          designed to streamline compliance, enhance user experience, and accelerate your business growth.
        </Typography>
      </Box>

      {/* Static Single Card */}
      <Box sx={{ display: "flex", justifyContent: "left" }}>
      <CategoryCard user={user} />
      </Box>
    </Box>
    </Wrapper>
  );
};

